// src/Redux/authInfluenceurSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    token: localStorage.getItem("authTokenInfluenceur") || null,
    email: localStorage.getItem("emailInfluenceur") || null,
    isAuthenticated: !!localStorage.getItem("authTokenInfluenceur"),
};

const authInfluenceurSlice = createSlice({
    name: "authInfluenceur",
    initialState,
    reducers: {
        setAuthInfluenceur: (state, action) => {
            const { token, email } = action.payload;

            if (token) {
                state.token = token;
                localStorage.setItem("authTokenInfluenceur", token);
            }

            if (email) {
                state.email = email;
                localStorage.setItem("emailInfluenceur", email);
            }

            state.isAuthenticated = !!state.token;
        },

        clearAuthInfluenceur: (state) => {
            state.token = null;
            state.email = null;
            state.isAuthenticated = false;

            localStorage.removeItem("authTokenInfluenceur");
            localStorage.removeItem("emailInfluenceur");
        },
    },
});

// Sélecteur
export const selectAuthInfluenceur = (state) => state.authInfluenceur;

export const { setAuthInfluenceur, clearAuthInfluenceur } = authInfluenceurSlice.actions;
export default authInfluenceurSlice.reducer;
